<template>
  <div>
    <!-- Mobile: bottom sheet -->
    <v-bottom-sheet
      v-if="isMobile"
      v-model="show"
      persistent
      content-class="app-promo-sheet-wrap"
      @keydown.esc="dismiss"
    >
      <v-sheet
        role="dialog"
        aria-modal="true"
        aria-labelledby="app-promo-mobile-title"
        class="app-promo-sheet"
      >
        <div class="app-promo-sheet__handle" aria-hidden="true"></div>

        <div class="app-promo-sheet__head">
          <div class="app-promo-sheet__logo" aria-hidden="true">G</div>
          <div>
            <div class="app-promo-sheet__brand">Gugla Empresas</div>
            <div class="app-promo-sheet__sub">Marrar, Lda. · Gratuita · Android</div>
          </div>
        </div>

        <h2 id="app-promo-mobile-title" class="app-promo-sheet__title">
          Leve os concursos no seu bolso
        </h2>
        <p class="app-promo-sheet__lead">
          A app é mais rápida que o site e avisa-o antes de cada prazo terminar.
        </p>

        <ul class="app-promo-sheet__features">
          <li v-for="(f, i) in features" :key="i">
            <span class="app-promo-sheet__ficon" aria-hidden="true" v-html="f.svg"></span>
            <span>{{ f.text }}</span>
          </li>
        </ul>

        <a
          :href="playStoreUrl"
          target="_blank"
          rel="noopener"
          class="app-promo-sheet__badge"
          ref="mobileCta"
          @click.prevent="openStore"
        >
          <img
            :src="badgeSrc"
            alt="Disponível no Google Play"
            width="220"
            height="85"
          />
        </a>
        <div class="app-promo-sheet__os">
          <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1E8E3E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>
          </svg>
          <span>Disponível apenas para <b>Android</b></span>
        </div>
        <button type="button" class="app-promo-sheet__dismiss" @click="dismiss">
          Continuar no browser
        </button>
      </v-sheet>
    </v-bottom-sheet>

    <!-- Desktop: modal centrado -->
    <v-dialog
      v-else
      v-model="show"
      max-width="900"
      persistent
      content-class="app-promo-dialog-wrap"
      @keydown.esc="dismiss"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="app-promo-desktop-title"
        class="app-promo-dialog"
      >
        <!-- Painel esquerdo: hero com telemóvel estilo Play Store -->
        <div class="app-promo-dialog__left" aria-hidden="true">
          <div class="app-promo-dialog__circle"></div>
          <div class="app-promo-dialog__hero-title">
            Acesso a diversos concursos públicos e privados
          </div>
          <div class="app-promo-dialog__phone">
            <div class="app-promo-dialog__screen">
              <div class="app-promo-dialog__camera"></div>

              <div class="app-promo-dialog__app-header">
                <div>
                  <div class="app-promo-dialog__greeting">Bom dia, Maria</div>
                  <div class="app-promo-dialog__app-title">Concursos</div>
                </div>
                <div class="app-promo-dialog__avatar">ML</div>
              </div>

              <div class="app-promo-dialog__search-row">
                <div class="app-promo-dialog__search-input">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#5F6368" stroke-width="2.4" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>
                  <span>Pesquisar concursos…</span>
                </div>
                <div class="app-promo-dialog__filter-btn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2.4" stroke-linecap="round"><path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0"/><circle cx="16" cy="6" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="18" cy="18" r="2"/></svg>
                </div>
              </div>

              <div class="app-promo-dialog__section-head">
                <span class="app-promo-dialog__section-title">Mais recentes</span>
                <span class="app-promo-dialog__section-count">248 concursos</span>
              </div>

              <div class="app-promo-dialog__card app-promo-dialog__card--red">
                <div class="app-promo-dialog__card-main">
                  <span class="app-promo-dialog__card-tag">Recomendado</span>
                  <div class="app-promo-dialog__card-title">Aquisição de Pastas de Arquivo</div>
                  <div class="app-promo-dialog__card-org">Ministério da Saúde</div>
                  <div class="app-promo-dialog__card-type">Concurso</div>
                  <div class="app-promo-dialog__card-chips">
                    <span class="app-promo-dialog__chip">Maputo</span>
                    <span class="app-promo-dialog__chip app-promo-dialog__chip--urgent">Faltam 2 dias</span>
                  </div>
                </div>
                <div class="app-promo-dialog__card-side">
                  <div class="app-promo-dialog__card-logo">G</div>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#B8B8B8" stroke-width="2"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>
                </div>
              </div>

              <div class="app-promo-dialog__card app-promo-dialog__card--green">
                <div class="app-promo-dialog__card-main">
                  <span class="app-promo-dialog__card-tag">Recomendado</span>
                  <div class="app-promo-dialog__card-title">SERVIÇOS TRANSPORTE E DISTRIBUIÇÃO DE VACINAS</div>
                  <div class="app-promo-dialog__card-org">Ministério da Saúde</div>
                  <div class="app-promo-dialog__card-type">Concurso</div>
                  <div class="app-promo-dialog__card-chips">
                    <span class="app-promo-dialog__chip">Maputo</span>
                    <span class="app-promo-dialog__chip app-promo-dialog__chip--date">28/10/2026</span>
                  </div>
                </div>
                <div class="app-promo-dialog__card-side">
                  <div class="app-promo-dialog__card-logo">G</div>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="#E2262A" stroke="#E2262A" stroke-width="2"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>
                </div>
              </div>

              <div class="app-promo-dialog__card app-promo-dialog__card--green app-promo-dialog__card--compact">
                <div class="app-promo-dialog__card-main">
                  <div class="app-promo-dialog__card-title">Serviços de Consultoria – Estradas Rurais</div>
                  <div class="app-promo-dialog__card-org">Administração Nacional de Estradas</div>
                  <div class="app-promo-dialog__card-type">Consultoria</div>
                </div>
                <div class="app-promo-dialog__card-logo">G</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Conteúdo direito -->
        <div class="app-promo-dialog__right">
          <button
            type="button"
            class="app-promo-dialog__close"
            aria-label="Fechar"
            ref="desktopClose"
            @click="dismiss"
          >
            <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <path d="M6 6l12 12M18 6L6 18"/>
            </svg>
          </button>

          <div class="app-promo-dialog__pill">NOVO · APP PARA ANDROID</div>
          <h2 id="app-promo-desktop-title" class="app-promo-dialog__title">
            Os concursos da Gugla Empresas, agora no seu telemóvel
          </h2>
          <p class="app-promo-dialog__lead">
            Instale a app gratuita para Android e acompanhe cada oportunidade onde estiver.
          </p>

          <ul class="app-promo-dialog__features">
            <li v-for="(f, i) in featuresDesktop" :key="i">
              <span class="app-promo-dialog__ficon" aria-hidden="true" v-html="f.svg"></span>
              <div>
                <div class="app-promo-dialog__ftitle">{{ f.title }}</div>
                <div class="app-promo-dialog__fdesc">{{ f.desc }}</div>
              </div>
            </li>
          </ul>

          <div class="app-promo-dialog__footer">
            <div class="app-promo-dialog__store-col">
              <a
                :href="playStoreUrl"
                target="_blank"
                rel="noopener"
                class="app-promo-dialog__badge"
                @click="trackStoreClick"
              >
                <img
                  :src="badgeSrc"
                  alt="Disponível no Google Play"
                  width="186"
                  height="72"
                />
              </a>
              <div class="app-promo-dialog__os">
                <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1E8E3E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>
                </svg>
                <span>Disponível apenas para <b>Android</b></span>
              </div>
            </div>
            <div class="app-promo-dialog__qr-row">
              <div class="app-promo-dialog__qr" aria-label="Código QR para a Play Store" role="img">
                <svg viewBox="0 0 39 39" width="64" height="64" xmlns="http://www.w3.org/2000/svg">
                  <rect width="39" height="39" fill="#FFFFFF"/>
                  <path :d="qrPath" fill="#111111"/>
                </svg>
              </div>
              <div class="app-promo-dialog__qr-text">
                Ou aponte a câmara para instalar
              </div>
            </div>
          </div>
          <div class="app-promo-dialog__dismiss">
            <a href="#" @click.prevent="dismiss">Agora não, continuar no site</a>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
const PACKAGE_ID = "com.marrar.gugla_empresas";
const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${PACKAGE_ID}`;
const DISMISS_KEY = "app_promo_dismissed_until";
const DISMISS_DAYS = 1;
const SHOW_DELAY_MS = 2500;
const BADGE_SRC = `${process.env.BASE_URL || "/"}images/google-play-badge-pt.png`;

const FEATURE_ICONS = {
  bell: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>',
  wallet: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>',
  heart: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>',
  phone: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><path d="M12 18h.01"/></svg>',
};

export default {
  name: "AppPromoDialog",

  data() {
    return {
      show: false,
      playStoreUrl: PLAY_STORE_URL,
      badgeSrc: BADGE_SRC,
      qrPath:
        "M1,1H2V2H1zM2,1H3V2H2zM3,1H4V2H3zM4,1H5V2H4zM5,1H6V2H5zM6,1H7V2H6zM7,1H8V2H7zM9,1H10V2H9zM10,1H11V2H10zM11,1H12V2H11zM12,1H13V2H12zM15,1H16V2H15zM19,1H20V2H19zM20,1H21V2H20zM24,1H25V2H24zM28,1H29V2H28zM29,1H30V2H29zM31,1H32V2H31zM32,1H33V2H32zM33,1H34V2H33zM34,1H35V2H34zM35,1H36V2H35zM36,1H37V2H36zM37,1H38V2H37zM1,2H2V3H1zM7,2H8V3H7zM10,2H11V3H10zM11,2H12V3H11zM13,2H14V3H13zM14,2H15V3H14zM15,2H16V3H15zM16,2H17V3H16zM18,2H19V3H18zM19,2H20V3H19zM21,2H22V3H21zM22,2H23V3H22zM25,2H26V3H25zM29,2H30V3H29zM31,2H32V3H31zM37,2H38V3H37zM1,3H2V4H1zM3,3H4V4H3zM4,3H5V4H4zM5,3H6V4H5zM7,3H8V4H7zM15,3H16V4H15zM16,3H17V4H16zM18,3H19V4H18zM19,3H20V4H19zM20,3H21V4H20zM21,3H22V4H21zM22,3H23V4H22zM27,3H28V4H27zM31,3H32V4H31zM33,3H34V4H33zM34,3H35V4H34zM35,3H36V4H35zM37,3H38V4H37zM1,4H2V5H1zM3,4H4V5H3zM4,4H5V5H4zM5,4H6V5H5zM7,4H8V5H7zM9,4H10V5H9zM11,4H12V5H11zM12,4H13V5H12zM14,4H15V5H14zM16,4H17V5H16zM20,4H21V5H20zM21,4H22V5H21zM24,4H25V5H24zM25,4H26V5H25zM26,4H27V5H26zM27,4H28V5H27zM28,4H29V5H28zM29,4H30V5H29zM31,4H32V5H31zM33,4H34V5H33zM34,4H35V5H34zM35,4H36V5H35zM37,4H38V5H37zM1,5H2V6H1zM3,5H4V6H3zM4,5H5V6H4zM5,5H6V6H5zM7,5H8V6H7zM9,5H10V6H9zM10,5H11V6H10zM13,5H14V6H13zM16,5H17V6H16zM17,5H18V6H17zM19,5H20V6H19zM23,5H24V6H23zM24,5H25V6H24zM26,5H27V6H26zM27,5H28V6H27zM28,5H29V6H28zM29,5H30V6H29zM31,5H32V6H31zM33,5H34V6H33zM34,5H35V6H34zM35,5H36V6H35zM37,5H38V6H37zM1,6H2V7H1zM7,6H8V7H7zM9,6H10V7H9zM11,6H12V7H11zM12,6H13V7H12zM13,6H14V7H13zM14,6H15V7H14zM19,6H20V7H19zM20,6H21V7H20zM21,6H22V7H21zM23,6H24V7H23zM26,6H27V7H26zM29,6H30V7H29zM31,6H32V7H31zM37,6H38V7H37zM1,7H2V8H1zM2,7H3V8H2zM3,7H4V8H3zM4,7H5V8H4zM5,7H6V8H5zM6,7H7V8H6zM7,7H8V8H7zM9,7H10V8H9zM11,7H12V8H11zM13,7H14V8H13zM15,7H16V8H15zM17,7H18V8H17zM19,7H20V8H19zM21,7H22V8H21zM23,7H24V8H23zM25,7H26V8H25zM27,7H28V8H27zM29,7H30V8H29zM31,7H32V8H31zM32,7H33V8H32zM33,7H34V8H33zM34,7H35V8H34zM35,7H36V8H35zM36,7H37V8H36zM37,7H38V8H37zM9,8H10V9H9zM11,8H12V9H11zM15,8H16V9H15zM18,8H19V9H18zM19,8H20V9H19zM22,8H23V9H22zM25,8H26V9H25zM27,8H28V9H27zM1,9H2V10H1zM5,9H6V10H5zM7,9H8V10H7zM8,9H9V10H8zM9,9H10V10H9zM12,9H13V10H12zM15,9H16V10H15zM19,9H20V10H19zM20,9H21V10H20zM22,9H23V10H22zM23,9H24V10H23zM24,9H25V10H24zM28,9H29V10H28zM30,9H31V10H30zM31,9H32V10H31zM32,9H33V10H32zM33,9H34V10H33zM34,9H35V10H34zM37,9H38V10H37zM2,10H3V11H2zM3,10H4V11H3zM4,10H5V11H4zM5,10H6V11H5zM6,10H7V11H6zM8,10H9V11H8zM11,10H12V11H11zM13,10H14V11H13zM14,10H15V11H14zM15,10H16V11H15zM17,10H18V11H17zM18,10H19V11H18zM20,10H21V11H20zM21,10H22V11H21zM23,10H24V11H23zM24,10H25V11H24zM26,10H27V11H26zM27,10H28V11H27zM28,10H29V11H28zM29,10H30V11H29zM33,10H34V11H33zM34,10H35V11H34zM36,10H37V11H36zM1,11H2V12H1zM5,11H6V12H5zM7,11H8V12H7zM10,11H11V12H10zM13,11H14V12H13zM14,11H15V12H14zM17,11H18V12H17zM19,11H20V12H19zM21,11H22V12H21zM22,11H23V12H22zM24,11H25V12H24zM26,11H27V12H26zM27,11H28V12H27zM28,11H29V12H28zM29,11H30V12H29zM30,11H31V12H30zM32,11H33V12H32zM34,11H35V12H34zM35,11H36V12H35zM1,12H2V13H1zM2,12H3V13H2zM3,12H4V13H3zM4,12H5V13H4zM5,12H6V13H5zM8,12H9V13H8zM10,12H11V13H10zM11,12H12V13H11zM13,12H14V13H13zM14,12H15V13H14zM18,12H19V13H18zM19,12H20V13H19zM22,12H23V13H22zM23,12H24V13H23zM24,12H25V13H24zM27,12H28V13H27zM30,12H31V13H30zM32,12H33V13H32zM33,12H34V13H33zM34,12H35V13H34zM35,12H36V13H35zM36,12H37V13H36zM1,13H2V14H1zM3,13H4V14H3zM5,13H6V14H5zM7,13H8V14H7zM8,13H9V14H8zM10,13H11V14H10zM12,13H13V14H12zM14,13H15V14H14zM15,13H16V14H15zM16,13H17V14H16zM17,13H18V14H17zM18,13H19V14H18zM20,13H21V14H20zM22,13H23V14H22zM23,13H24V14H23zM25,13H26V14H25zM28,13H29V14H28zM30,13H31V14H30zM31,13H32V14H31zM34,13H35V14H34zM35,13H36V14H35zM36,13H37V14H36zM37,13H38V14H37zM1,14H2V15H1zM2,14H3V15H2zM6,14H7V15H6zM8,14H9V15H8zM10,14H11V15H10zM11,14H12V15H11zM12,14H13V15H12zM15,14H16V15H15zM16,14H17V15H16zM17,14H18V15H17zM18,14H19V15H18zM19,14H20V15H19zM24,14H25V15H24zM25,14H26V15H25zM26,14H27V15H26zM27,14H28V15H27zM28,14H29V15H28zM29,14H30V15H29zM33,14H34V15H33zM34,14H35V15H34zM1,15H2V16H1zM3,15H4V16H3zM6,15H7V16H6zM7,15H8V16H7zM8,15H9V16H8zM10,15H11V16H10zM14,15H15V16H14zM15,15H16V16H15zM16,15H17V16H16zM17,15H18V16H17zM19,15H20V16H19zM23,15H24V16H23zM24,15H25V16H24zM25,15H26V16H25zM26,15H27V16H26zM27,15H28V16H27zM28,15H29V16H28zM30,15H31V16H30zM32,15H33V16H32zM33,15H34V16H33zM34,15H35V16H34zM35,15H36V16H35zM2,16H3V17H2zM5,16H6V17H5zM8,16H9V17H8zM14,16H15V17H14zM15,16H16V17H15zM16,16H17V17H16zM22,16H23V17H22zM24,16H25V17H24zM25,16H26V17H25zM27,16H28V17H27zM32,16H33V17H32zM33,16H34V17H33zM35,16H36V17H35zM2,17H3V18H2zM3,17H4V18H3zM5,17H6V18H5zM7,17H8V18H7zM10,17H11V18H10zM11,17H12V18H11zM13,17H14V18H13zM15,17H16V18H15zM16,17H17V18H16zM17,17H18V18H17zM20,17H21V18H20zM21,17H22V18H21zM22,17H23V18H22zM23,17H24V18H23zM24,17H25V18H24zM30,17H31V18H30zM31,17H32V18H31zM32,17H33V18H32zM34,17H35V18H34zM35,17H36V18H35zM2,18H3V19H2zM5,18H6V19H5zM10,18H11V19H10zM11,18H12V19H11zM15,18H16V19H15zM19,18H20V19H19zM20,18H21V19H20zM22,18H23V19H22zM24,18H25V19H24zM27,18H28V19H27zM28,18H29V19H28zM30,18H31V19H30zM33,18H34V19H33zM34,18H35V19H34zM35,18H36V19H35zM36,18H37V19H36zM2,19H3V20H2zM4,19H5V20H4zM7,19H8V20H7zM9,19H10V20H9zM10,19H11V20H10zM11,19H12V20H11zM16,19H17V20H16zM18,19H19V20H18zM19,19H20V20H19zM20,19H21V20H20zM24,19H25V20H24zM25,19H26V20H25zM27,19H28V20H27zM28,19H29V20H28zM29,19H30V20H29zM31,19H32V20H31zM33,19H34V20H33zM35,19H36V20H35zM4,20H5V21H4zM5,20H6V21H5zM8,20H9V21H8zM9,20H10V21H9zM10,20H11V21H10zM13,20H14V21H13zM15,20H16V21H15zM16,20H17V21H16zM17,20H18V21H17zM18,20H19V21H18zM20,20H21V21H20zM21,20H22V21H21zM22,20H23V21H22zM24,20H25V21H24zM25,20H26V21H25zM29,20H30V21H29zM30,20H31V21H30zM32,20H33V21H32zM33,20H34V21H33zM35,20H36V21H35zM36,20H37V21H36zM3,21H4V22H3zM5,21H6V22H5zM7,21H8V22H7zM8,21H9V22H8zM9,21H10V22H9zM12,21H13V22H12zM15,21H16V22H15zM18,21H19V22H18zM22,21H23V22H22zM23,21H24V22H23zM24,21H25V22H24zM25,21H26V22H25zM30,21H31V22H30zM31,21H32V22H31zM32,21H33V22H32zM35,21H36V22H35zM1,22H2V23H1zM6,22H7V23H6zM8,22H9V23H8zM10,22H11V23H10zM11,22H12V23H11zM12,22H13V23H12zM13,22H14V23H13zM14,22H15V23H14zM15,22H16V23H15zM16,22H17V23H16zM17,22H18V23H17zM19,22H20V23H19zM23,22H24V23H23zM24,22H25V23H24zM27,22H28V23H27zM28,22H29V23H28zM29,22H30V23H29zM32,22H33V23H32zM33,22H34V23H33zM1,23H2V24H1zM2,23H3V24H2zM3,23H4V24H3zM4,23H5V24H4zM7,23H8V24H7zM8,23H9V24H8zM9,23H10V24H9zM10,23H11V24H10zM12,23H13V24H12zM13,23H14V24H13zM14,23H15V24H14zM16,23H17V24H16zM18,23H19V24H18zM21,23H22V24H21zM22,23H23V24H22zM23,23H24V24H23zM24,23H25V24H24zM25,23H26V24H25zM27,23H28V24H27zM28,23H29V24H28zM29,23H30V24H29zM30,23H31V24H30zM32,23H33V24H32zM33,23H34V24H33zM34,23H35V24H34zM35,23H36V24H35zM4,24H5V25H4zM6,24H7V25H6zM8,24H9V25H8zM9,24H10V25H9zM10,24H11V25H10zM11,24H12V25H11zM12,24H13V25H12zM14,24H15V25H14zM16,24H17V25H16zM17,24H18V25H17zM18,24H19V25H18zM19,24H20V25H19zM22,24H23V25H22zM25,24H26V25H25zM30,24H31V25H30zM31,24H32V25H31zM32,24H33V25H32zM33,24H34V25H33zM35,24H36V25H35zM37,24H38V25H37zM1,25H2V26H1zM2,25H3V26H2zM3,25H4V26H3zM5,25H6V26H5zM7,25H8V26H7zM12,25H13V26H12zM13,25H14V26H13zM16,25H17V26H16zM19,25H20V26H19zM20,25H21V26H20zM22,25H23V26H22zM23,25H24V26H23zM24,25H25V26H24zM25,25H26V26H25zM28,25H29V26H28zM29,25H30V26H29zM30,25H31V26H30zM31,25H32V26H31zM32,25H33V26H32zM34,25H35V26H34zM35,25H36V26H35zM36,25H37V26H36zM1,26H2V27H1zM4,26H5V27H4zM6,26H7V27H6zM8,26H9V27H8zM10,26H11V27H10zM13,26H14V27H13zM14,26H15V27H14zM15,26H16V27H15zM17,26H18V27H17zM20,26H21V27H20zM21,26H22V27H21zM23,26H24V27H23zM24,26H25V27H24zM26,26H27V27H26zM27,26H28V27H27zM28,26H29V27H28zM29,26H30V27H29zM30,26H31V27H30zM32,26H33V27H32zM33,26H34V27H33zM5,27H6V28H5zM6,27H7V28H6zM7,27H8V28H7zM10,27H11V28H10zM12,27H13V28H12zM14,27H15V28H14zM15,27H16V28H15zM17,27H18V28H17zM18,27H19V28H18zM19,27H20V28H19zM21,27H22V28H21zM23,27H24V28H23zM24,27H25V28H24zM25,27H26V28H25zM27,27H28V28H27zM28,27H29V28H28zM30,27H31V28H30zM32,27H33V28H32zM3,28H4V29H3zM5,28H6V29H5zM6,28H7V29H6zM9,28H10V29H9zM10,28H11V29H10zM14,28H15V29H14zM18,28H19V29H18zM19,28H20V29H19zM22,28H23V29H22zM23,28H24V29H23zM24,28H25V29H24zM25,28H26V29H25zM27,28H28V29H27zM28,28H29V29H28zM29,28H30V29H29zM32,28H33V29H32zM33,28H34V29H33zM35,28H36V29H35zM37,28H38V29H37zM1,29H2V30H1zM2,29H3V30H2zM3,29H4V30H3zM5,29H6V30H5zM7,29H8V30H7zM9,29H10V30H9zM10,29H11V30H10zM12,29H13V30H12zM14,29H15V30H14zM16,29H17V30H16zM18,29H19V30H18zM20,29H21V30H20zM21,29H22V30H21zM22,29H23V30H22zM23,29H24V30H23zM25,29H26V30H25zM27,29H28V30H27zM29,29H30V30H29zM30,29H31V30H30zM31,29H32V30H31zM32,29H33V30H32zM33,29H34V30H33zM35,29H36V30H35zM36,29H37V30H36zM37,29H38V30H37zM9,30H10V31H9zM10,30H11V31H10zM12,30H13V31H12zM14,30H15V31H14zM16,30H17V31H16zM17,30H18V31H17zM18,30H19V31H18zM24,30H25V31H24zM26,30H27V31H26zM27,30H28V31H27zM29,30H30V31H29zM33,30H34V31H33zM36,30H37V31H36zM1,31H2V32H1zM2,31H3V32H2zM3,31H4V32H3zM4,31H5V32H4zM5,31H6V32H5zM6,31H7V32H6zM7,31H8V32H7zM9,31H10V32H9zM11,31H12V32H11zM14,31H15V32H14zM15,31H16V32H15zM16,31H17V32H16zM19,31H20V32H19zM21,31H22V32H21zM23,31H24V32H23zM24,31H25V32H24zM25,31H26V32H25zM29,31H30V32H29zM31,31H32V32H31zM33,31H34V32H33zM36,31H37V32H36zM1,32H2V33H1zM7,32H8V33H7zM13,32H14V33H13zM14,32H15V33H14zM15,32H16V33H15zM16,32H17V33H16zM17,32H18V33H17zM20,32H21V33H20zM21,32H22V33H21zM22,32H23V33H22zM27,32H28V33H27zM28,32H29V33H28zM29,32H30V33H29zM33,32H34V33H33zM34,32H35V33H34zM35,32H36V33H35zM37,32H38V33H37zM1,33H2V34H1zM3,33H4V34H3zM4,33H5V34H4zM5,33H6V34H5zM7,33H8V34H7zM9,33H10V34H9zM10,33H11V34H10zM13,33H14V34H13zM14,33H15V34H14zM15,33H16V34H15zM17,33H18V34H17zM21,33H22V34H21zM25,33H26V34H25zM26,33H27V34H26zM29,33H30V34H29zM30,33H31V34H30zM31,33H32V34H31zM32,33H33V34H32zM33,33H34V34H33zM34,33H35V34H34zM35,33H36V34H35zM37,33H38V34H37zM1,34H2V35H1zM3,34H4V35H3zM4,34H5V35H4zM5,34H6V35H5zM7,34H8V35H7zM10,34H11V35H10zM11,34H12V35H11zM19,34H20V35H19zM20,34H21V35H20zM24,34H25V35H24zM28,34H29V35H28zM30,34H31V35H30zM31,34H32V35H31zM32,34H33V35H32zM34,34H35V35H34zM35,34H36V35H35zM37,34H38V35H37zM1,35H2V36H1zM3,35H4V36H3zM4,35H5V36H4zM5,35H6V36H5zM7,35H8V36H7zM11,35H12V36H11zM16,35H17V36H16zM18,35H19V36H18zM19,35H20V36H19zM20,35H21V36H20zM22,35H23V36H22zM24,35H25V36H24zM25,35H26V36H25zM26,35H27V36H26zM27,35H28V36H27zM28,35H29V36H28zM31,35H32V36H31zM1,36H2V37H1zM7,36H8V37H7zM10,36H11V37H10zM11,36H12V37H11zM12,36H13V37H12zM13,36H14V37H13zM14,36H15V37H14zM16,36H17V37H16zM17,36H18V37H17zM18,36H19V37H18zM20,36H21V37H20zM21,36H22V37H21zM22,36H23V37H22zM25,36H26V37H25zM28,36H29V37H28zM30,36H31V37H30zM33,36H34V37H33zM35,36H36V37H35zM36,36H37V37H36zM1,37H2V38H1zM2,37H3V38H2zM3,37H4V38H3zM4,37H5V38H4zM5,37H6V38H5zM6,37H7V38H6zM7,37H8V38H7zM9,37H10V38H9zM10,37H11V38H10zM14,37H15V38H14zM18,37H19V38H18zM21,37H22V38H21zM22,37H23V38H22zM24,37H25V38H24zM25,37H26V38H25zM28,37H29V38H28zM32,37H33V38H32zM35,37H36V38H35zM36,37H37V38H36zM37,37H38V38H37z",
      features: [
        { svg: FEATURE_ICONS.bell, text: "Notificações de prazos de submissão" },
        { svg: FEATURE_ICONS.wallet, text: "Caderno de Encargos com M-Pesa ou e-Mola" },
        { svg: FEATURE_ICONS.heart, text: "Favoritos sempre à mão" },
      ],
      featuresDesktop: [
        {
          svg: FEATURE_ICONS.bell,
          title: "Nunca perca um prazo",
          desc: "Receba uma notificação antes de cada prazo de submissão terminar.",
        },
        {
          svg: FEATURE_ICONS.phone,
          title: "Compre o Caderno de Encargos na app",
          desc: "Pague com M-Pesa ou e-Mola sem sair do telemóvel.",
        },
        {
          svg: FEATURE_ICONS.heart,
          title: "Os seus favoritos à mão",
          desc: "Guarde os concursos que lhe interessam e volte a eles num toque.",
        },
      ],
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },

  mounted() {
    setTimeout(this.maybeShow, SHOW_DELAY_MS);
  },

  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => {
          const el = this.isMobile ? this.$refs.mobileCta : this.$refs.desktopClose;
          if (el && typeof el.focus === "function") el.focus();
        });
      }
    },
  },

  methods: {
    maybeShow() {
      if (this.isInApp()) return;
      if (this.isIos()) return;
      try {
        const until = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
        if (!isNaN(until) && Date.now() < until) return;
      } catch (e) {
        /* localStorage bloqueado — mostra na mesma */
      }
      this.show = true;
    },
    isInApp() {
      const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
      if (/GuglaEmpresasApp/i.test(ua)) return true;
      if (/Android.*;\s*wv\)/i.test(ua)) return true;
      return false;
    },
    isIos() {
      const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
      return /iPhone|iPad|iPod/i.test(ua);
    },
    dismiss() {
      try {
        const until = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
        localStorage.setItem(DISMISS_KEY, String(until));
      } catch (e) {
        /* ignorar */
      }
      this.show = false;
    },
    openStore() {
      const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
      const isAndroid = /Android/i.test(ua);
      this.dismiss();
      if (isAndroid) {
        const fallback = window.setTimeout(() => {
          window.location.href = PLAY_STORE_URL;
        }, 800);
        window.addEventListener(
          "pagehide",
          () => window.clearTimeout(fallback),
          { once: true }
        );
        window.location.href = `market://details?id=${PACKAGE_ID}`;
      } else {
        window.open(PLAY_STORE_URL, "_blank", "noopener");
      }
    },
    trackStoreClick() {
      this.dismiss();
    },
  },
};
</script>

<style scoped>
/* ====== Vuetify wrapper overrides ====== */
/* v-dialog aplica .v-dialog ao content-class; redefine os seus defaults
   (border-radius 4px, overflow-y auto, box-shadow, max-height 90vh) para
   que o cartão interno fique íntegro. */
::v-deep .v-dialog.app-promo-dialog-wrap {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
  margin: 24px;
}
::v-deep .v-dialog.app-promo-sheet-wrap {
  border-radius: 24px 24px 0 0;
  overflow: hidden;
  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.25);
  margin: 0;
  width: 100%;
  max-width: 100%;
}

/* ====== Mobile bottom sheet ====== */
.app-promo-sheet {
  background: #ffffff;
  border-radius: 24px 24px 0 0;
  padding: 12px 24px 28px;
  display: flex;
  flex-direction: column;
  font-family: Roboto, Arial, sans-serif;
  color: #1f1f1f;
}
.app-promo-sheet__handle {
  align-self: center;
  width: 40px;
  height: 4px;
  border-radius: 2px;
  background: #dadce0;
}
.app-promo-sheet__head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 22px;
}
.app-promo-sheet__logo {
  width: 60px;
  height: 60px;
  flex: none;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  color: #e3141e;
  font-weight: 900;
  font-size: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-promo-sheet__brand {
  font-size: 17px;
  font-weight: 700;
}
.app-promo-sheet__sub {
  font-size: 13px;
  color: #5f6368;
  margin-top: 3px;
}
.app-promo-sheet__title {
  margin: 20px 0 0;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 900;
  letter-spacing: -0.3px;
}
.app-promo-sheet__lead {
  margin: 8px 0 0;
  font-size: 15px;
  line-height: 1.5;
  color: #3c4043;
}
.app-promo-sheet__features {
  list-style: none;
  margin: 18px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.app-promo-sheet__features li {
  display: flex;
  gap: 12px;
  align-items: center;
  font-size: 14px;
}
.app-promo-sheet__ficon {
  width: 32px;
  height: 32px;
  flex: none;
  border-radius: 10px;
  background: #fdecec;
  color: #e3141e;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-promo-sheet__badge {
  margin-top: 20px;
  align-self: center;
  display: block;
  line-height: 0;
}
.app-promo-sheet__badge img {
  width: 220px;
  height: auto;
  display: block;
}
.app-promo-sheet__os {
  margin: 10px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  color: #3c4043;
  line-height: 1.4;
}
.app-promo-sheet__os b {
  font-weight: 700;
}
.app-promo-sheet__dismiss {
  margin-top: 8px;
  height: 44px;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 14px;
  color: #5f6368;
  cursor: pointer;
}

/* ====== Desktop dialog ====== */
.app-promo-dialog {
  width: 100%;
  min-height: 540px;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  display: grid;
  grid-template-columns: 360px 1fr;
  font-family: Roboto, Arial, sans-serif;
  color: #1f1f1f;
  box-sizing: border-box;
}

/* Painel esquerdo: gradiente estilo Play Store */
.app-promo-dialog__left {
  background: linear-gradient(170deg, #ff8e53 0%, #f4592e 55%, #e2262a 100%);
  position: relative;
  overflow: hidden;
}
.app-promo-dialog__circle {
  position: absolute;
  width: 360px;
  height: 360px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.13);
  right: -150px;
  top: -170px;
}
.app-promo-dialog__hero-title {
  position: relative;
  margin: 38px 28px 0;
  text-align: center;
  color: #ffffff;
  font-size: 26px;
  line-height: 1.12;
  font-weight: 900;
  letter-spacing: -0.4px;
  text-shadow: 0 2px 8px rgba(120, 20, 0, 0.18);
}

/* Telemóvel */
.app-promo-dialog__phone {
  position: absolute;
  left: 50%;
  top: 158px;
  transform: translateX(-50%);
  width: 272px;
  height: 520px;
  background: #141414;
  border-radius: 40px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 18px 40px rgba(90, 10, 0, 0.35);
}
.app-promo-dialog__screen {
  position: relative;
  width: 100%;
  height: 100%;
  background: #f4f4f4;
  border-radius: 31px;
  overflow: hidden;
  padding: 30px 14px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.app-promo-dialog__camera {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #141414;
}
.app-promo-dialog__app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.app-promo-dialog__greeting {
  font-size: 9px;
  color: #6b6b6b;
}
.app-promo-dialog__app-title {
  font-size: 21px;
  font-weight: 900;
  letter-spacing: -0.4px;
  margin-top: 1px;
}
.app-promo-dialog__avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #ff4a12;
  box-shadow: 0 0 0 3px #ffffff, 0 0 0 4.5px #ffb49a;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-promo-dialog__search-row {
  display: flex;
  gap: 8px;
  align-items: center;
}
.app-promo-dialog__search-input {
  flex: 1;
  height: 32px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  font-size: 10px;
  color: #8a8a8a;
}
.app-promo-dialog__filter-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ff4a12;
  box-shadow: 0 4px 10px rgba(255, 74, 18, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-promo-dialog__section-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 2px;
}
.app-promo-dialog__section-title {
  font-size: 11px;
  font-weight: 700;
}
.app-promo-dialog__section-count {
  font-size: 8px;
  color: #8a8a8a;
}

/* Cartões de concurso */
.app-promo-dialog__card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  padding: 9px 10px;
  display: flex;
  gap: 8px;
}
.app-promo-dialog__card--red {
  border-left: 3px solid #e2262a;
}
.app-promo-dialog__card--green {
  border-left: 3px solid #5bc236;
}
.app-promo-dialog__card--compact {
  align-items: center;
}
.app-promo-dialog__card-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.app-promo-dialog__card-tag {
  align-self: flex-start;
  font-size: 7px;
  font-weight: 700;
  color: #ffffff;
  background: #2e7d32;
  border-radius: 3px;
  padding: 1px 5px;
}
.app-promo-dialog__card-title {
  font-size: 9.5px;
  font-weight: 700;
  line-height: 1.25;
}
.app-promo-dialog__card-org {
  font-size: 8px;
  color: #6b6b6b;
}
.app-promo-dialog__card-type {
  font-size: 8px;
  color: #d3161e;
}
.app-promo-dialog__card-chips {
  display: flex;
  gap: 4px;
  margin-top: 3px;
}
.app-promo-dialog__chip {
  font-size: 7px;
  background: #eeeeee;
  color: #444444;
  border-radius: 8px;
  padding: 2px 6px;
}
.app-promo-dialog__chip--urgent {
  background: #fde4e4;
  color: #c5161d;
}
.app-promo-dialog__chip--date {
  background: #e3f4e0;
  color: #2e7d32;
}
.app-promo-dialog__card-side {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}
.app-promo-dialog__card-logo {
  width: 36px;
  height: 36px;
  flex: none;
  border-radius: 8px;
  border: 1px solid #e3e3e3;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Roboto, Arial, sans-serif;
  font-size: 24px;
  font-weight: 900;
  line-height: 1;
  color: #e3141e;
}

/* Painel direito (conteúdo) */
.app-promo-dialog__right {
  position: relative;
  padding: 40px 44px 32px 44px;
  display: flex;
  flex-direction: column;
}
.app-promo-dialog__close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5f6368;
}
.app-promo-dialog__close:hover {
  background: #f1f3f4;
  color: #1f1f1f;
}
.app-promo-dialog__pill {
  align-self: flex-start;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #e3141e;
  background: #fdecec;
  border-radius: 999px;
  padding: 5px 12px;
}
.app-promo-dialog__title {
  margin: 14px 0 0;
  font-size: 30px;
  line-height: 1.15;
  font-weight: 900;
  letter-spacing: -0.5px;
}
.app-promo-dialog__lead {
  margin: 10px 0 0;
  font-size: 15px;
  line-height: 1.5;
  color: #3c4043;
}
.app-promo-dialog__features {
  list-style: none;
  margin: 22px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.app-promo-dialog__features li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.app-promo-dialog__ficon {
  width: 34px;
  height: 34px;
  flex: none;
  border-radius: 10px;
  background: #fdecec;
  color: #e3141e;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-promo-dialog__ftitle {
  font-size: 14px;
  font-weight: 700;
}
.app-promo-dialog__fdesc {
  font-size: 13px;
  color: #5f6368;
  margin-top: 2px;
}
.app-promo-dialog__footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 20px;
}
.app-promo-dialog__store-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.app-promo-dialog__badge {
  display: block;
  line-height: 0;
}
.app-promo-dialog__badge img {
  width: 186px;
  height: auto;
  display: block;
}
.app-promo-dialog__qr-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.app-promo-dialog__qr {
  width: 64px;
  height: 64px;
  padding: 2px;
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-promo-dialog__qr-text {
  font-size: 12px;
  color: #5f6368;
  line-height: 1.4;
  width: 110px;
}
.app-promo-dialog__os {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #3c4043;
  line-height: 1.4;
}
.app-promo-dialog__os b {
  font-weight: 700;
}
.app-promo-dialog__dismiss {
  margin-top: 14px;
}
.app-promo-dialog__dismiss a {
  font-size: 13px;
  color: #5f6368;
}
.app-promo-dialog__dismiss a:hover {
  color: #1f1f1f;
}
</style>
